<template>
  <div
   ref="floatingRoot"
   v-if="rideHeader &&
         rideHeader.ride &&
         rideHeader.ride.id &&
         compareToUserId( rideHeader.ride.authorId ) &&
         allRide &&
         allRide.ride &&
         allRide.ride.is_based_ride"
   class="whatsapp-icon-container-with add-attraction-from-image-container"
   :style="floatingStyle">
    <router-link
      :to="currentUrlWithRideID"
      rel="noopener noreferrer">
      <span>{{ t('addAccommodationAiButton') }}</span>
    </router-link>
  </div>
</template>



<script >
import { mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';
import {
  getFloatingItemStyle,
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
} from "@/services/floatingItems";

export default {
  name: 'AddAtractionFromImage',
  mixins: [translationMixin],
  data() {
    return {
      floatingId: "floating-add-accommodation",
    };
  },
  computed: { ...mapGetters([ 'rideHeader',
                              'compareToUserId', 
                              'allRide',
                            ]),
    shouldShow() {
      return (
        this.rideHeader &&
        this.rideHeader.ride &&
        this.rideHeader.ride.id &&
        this.compareToUserId(this.rideHeader.ride.authorId) &&
        this.allRide &&
        this.allRide.ride &&
        this.allRide.ride.is_based_ride
      );
    },
    floatingStyle() {
      return getFloatingItemStyle(this.floatingId);
    },
    currentUrlWithRideID() {
      return `/add_accommodations_image/${this.rideHeader.ride.id}`;
    }
  },
  watch: {
    shouldShow() {
      this.syncFloatingState();
    },
  },
  mounted() {
    registerFloatingItem({
      id: this.floatingId,
      priority: 20,
      anchor: "right",
      zIndex: 999,
    });
    this.syncFloatingState();
  },
  beforeDestroy() {
    unregisterFloatingItem(this.floatingId);
  },
  methods: {
    syncFloatingState() {
      this.$nextTick(() => {
        const root = this.$refs.floatingRoot;
        updateFloatingItem(this.floatingId, {
          visible: !!this.shouldShow,
          height: this.shouldShow && root ? root.offsetHeight : 0,
        });
      });
    },
  },

}
</script>

<style scoped>

.add-attraction-from-image-container {
  max-width: calc(100vw - 40px);
}

.add-attraction-from-image-container a {
  display: flex; /* Changed to flex to align icon and text */
  align-items: center; /* Align items vertically */
  background-color: #25d366;
  padding: 10px;
  border-radius: 10px; /* Slightly rounded corners */
  text-decoration: none; /* Remove underline from text */
}

.add-attraction-from-image-container img {
  width: 30px;
  height: 30px;
  margin-left: 10px; /* Add space between icon and text */
}

.add-attraction-from-image-container span {
  color: white; /* Text color */
  font-size: 14px; /* Adjust as needed */
}

</style>
